// Tailwind CSS (for migration to shadcn-ui)
import './styles/tailwind.css';

import * as React from 'react';
import { root as RouterRoot } from '@/routes/root';

// Locales
import ThemeLocalization from '@/locales';
import { QueryProvider } from '@/providers';
import ErrorBoundary from '@/errors/ErrorBoundary';
import { isFeatureEnabled } from '@/config/featureFlags';
import { Toaster } from '@/components/ui/sonner';
import ToastContainer from '@/ui/toast';
import { ChatWidget } from '@/components/chat-widget';
import { useSyncThemeMode } from '@/theme/useSyncThemeMode';

import './styles/main.scss';

const chatWidgetEnabled = import.meta.env.VITE_CHAT_WIDGET_ENABLED !== 'false';

export default function App() {
  const useErrors = isFeatureEnabled('useNormalizedErrors');
  useSyncThemeMode();

  return (
    <QueryProvider>
      <ThemeLocalization>
        {useErrors ? (
          <ErrorBoundary boundaryName="root-app">
            <RouterRoot />
          </ErrorBoundary>
        ) : (
          <RouterRoot />
        )}
        <Toaster position="top-right" />
        <ToastContainer />
        {chatWidgetEnabled && <ChatWidget />}
      </ThemeLocalization>
    </QueryProvider>
  );
}
